import { render, staticRenderFns } from "./BaseObligatoryIcon.vue?vue&type=template&id=22dac773"
import script from "./BaseObligatoryIcon.vue?vue&type=script&lang=js"
export * from "./BaseObligatoryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports